/**
 * Yotpo reviews drawer controller — Horizon-native.
 *
 * Opens the reviews drawer (snippets/yotpo-overlay.liquid) when any element with the
 * .yotpo-sr-placeholder class is clicked or keyboard-activated (e.g. the PDP rating's
 * "(N Reviews)" link), and closes it on the close button, backdrop click, or Escape. Locks body
 * scroll while open (restoring any prior lock on close). Mirrors the reference theme's overlay
 * behavior; no reference code is copied.
 */
(function () {
  function overlay() {
    return document.querySelector('[data-yotpo-overlay]');
  }

  function open() {
    var o = overlay();
    if (!o) return;
    o.hidden = false;
    // Next frame so the transition runs from the hidden state.
    requestAnimationFrame(function () {
      o.classList.add('is-open');
    });
    // Save any existing inline scroll-lock so we don't clobber another open component's lock.
    o._prevHtmlOverflow = document.documentElement.style.overflow;
    o._prevBodyOverflow = document.body.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function close() {
    var o = overlay();
    if (!o) return;
    o.classList.remove('is-open');
    document.documentElement.style.overflow = o._prevHtmlOverflow || '';
    document.body.style.overflow = o._prevBodyOverflow || '';
    window.setTimeout(function () {
      if (!o.classList.contains('is-open')) o.hidden = true;
    }, 300);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    if (target.closest('.yotpo-sr-placeholder')) {
      event.preventDefault();
      open();
      return;
    }

    if (target.closest('[data-yotpo-close]')) {
      close();
      return;
    }

    // Click on the backdrop itself (not the panel) closes the drawer.
    var o = overlay();
    if (o && !o.hidden && target === o) {
      close();
    }
  });

  // Keyboard activation for the role="button" trigger (Enter / Space).
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
      var target = event.target;
      if (target instanceof Element && target.closest('.yotpo-sr-placeholder')) {
        event.preventDefault();
        open();
      }
    }
  });
})();
